import { render } from "./GirlPostList.vue?vue&type=template&id=22b329e1"
import script from "./GirlPostList.vue?vue&type=script&lang=js"
export * from "./GirlPostList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__